import { Box, Container, Typography } from '@mui/material';
import Link from '../../components/Link';
import ScrollToTop from '../../components/ScrollToTop';
import StepWizard from './StepWizard';

export default function ElectrifyRoomsV2({
  rooms,
  room,
  my_project: myProject,
  incentives,
  filters,
  products_by_rating: productsByRating,
  resources,
  incentive_imgix: incentiveImgix,
}) {
  return (
    <Box position="relative" bgcolor="grey.100">
      {/* mobile top bar */}
      <Box
        display={{ xs: 'flex', md: 'none' }}
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid"
        borderColor="gray.200"
        py={2}
        px={{ xs: 2, sm: 3 }}
      >
        <Link href="/" arrowDirection="left" textTransform="uppercase" color="common.black">
          <Typography variant="h4" component="p" fontWeight="bold" fontSize="0.875rem">
            Back
          </Typography>
        </Link>
      </Box>

      <Container sx={{ pb: 14 }}>
        <Box pt={{ xs: 4, sm: 4.5 }} display="flex" flexDirection="column" alignItems="center">
          <Typography component="h1" display="flex" flexDirection="column">
            <Typography
              variant="body"
              component="span"
              fontSize={{ xs: '0.875rem', sm: '1.125rem' }}
              fontWeight={700}
              textTransform="uppercase"
              textAlign="center"
              mb={1}
            >
              Start your electric home plan
            </Typography>
            <Typography
              variant="h2"
              fontWeight={500}
              component="span"
              textAlign="center"
              maxWidth="50rem"
              mb={1}
            >
              Boost comfort and savings.
              <br />
              Create a more sustainable home.
            </Typography>
          </Typography>

          <StepWizard
            rooms={rooms}
            room={room}
            myProject={myProject}
            incentives={incentives}
            filters={filters}
            productsByRating={productsByRating}
            resources={resources}
            incentiveImgix={incentiveImgix}
          />
        </Box>

        <ScrollToTop />
      </Container>
    </Box>
  );
}
